/* eslint-disable */
import { Eye, EyeOff } from 'lucide-react';

const Legend = (props) => {
    const {
        list,
        setIsLegend,
        isClickable = false,
        selectedLegend = null,
        multiSelect = false
    } = props;

    const isItemActive = (value) => {
        if (multiSelect) {
            return Array.isArray(selectedLegend) && selectedLegend.includes(value);
        }
        return selectedLegend === value;
    };

    const handleSetSelected = (value) => {
        if (!isClickable) return;

        if (multiSelect) {
            const currentSelected = Array.isArray(selectedLegend) ? selectedLegend : [];
            let newSelected;
            if (currentSelected.includes(value)) {
                newSelected = currentSelected.filter(v => v !== value);
            } else {
                newSelected = [...currentSelected, value];
            }
            setIsLegend(newSelected.length > 0 ? newSelected : null);
        } else {
            const newValue = selectedLegend === value ? null : value;
            setIsLegend(newValue);
        }
    };

    return (
        <div
            className='absolute top-[2.5rem] left-0 bg-white shadow-lg rounded-md p-3 z-[1000] min-w-[200px] border border-gray-200'
            onClick={(e) => e.stopPropagation()}
        >
            <div className='text-sm text-gray-400 mb-3'>
                Legend {multiSelect && <span className='text-xs'>(Multi-select)</span>}
            </div>
            <div className='flex flex-col gap-3'>
                {list?.map((item) => {
                    const isActive = isItemActive(item?.value);
                    return (
                        <div
                            key={item?.value}
                            onClick={() => handleSetSelected(item?.value)}
                            className={`flex items-center justify-between gap-3 ${isClickable ? 'cursor-pointer' : ''}`}>
                            <div className={`flex items-center gap-2 ${isActive ? 'text-gray-600' : ''}`}>
                                {item?.img ? <img src={item?.img} alt={item?.label} className='w-5 h-5' /> : item?.icon}
                                <span className='text-sm font-medium'>{item?.label}</span>
                            </div>
                            {item?.showEye && (
                                isActive
                                    ? <EyeOff size={16} className='text-gray-400' />
                                    : <Eye size={16} />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Legend;
